<ng-container *ngIf="modelIds$ && asOfDate; else loading">
	<section class="padding-bottom-20 dz-hidden dz-block-lg" *ngIf="asOfDate">
		<span><span dcrHTMLKey="FAMILY_AS_OF">As of</span> {{ asOfDate }}</span>
		<span *ngIf="modelIdsList.length > config?.options?.componentBreakpoint" class="dz-pull-right text-14" dcrHTMLKey="SCROLL_RIGHT_INDICATOR"></span>
	</section>
	<ng-template [componentId]="{ componentId: 'me.family.latestHoldings', ids: modelIds$ }" let-detailsData [error]="errorTemplate">
		<ng-template [componentId]="{ componentId: 'me.family.latestHoldings', ids: familyIds$ }" let-headerData [error]="errorTemplate">
			<section class="bordered-container family-latest-holding-table-container no-padding">
				<hl-holdings-table-header
					[data]="headerData"
					[holdingsData]="detailsData"
					[dataTabId]="'latestHoldings.header'"
					[holdingsDataTabId]="'latestHoldings'"
					[modelIds]="modelIds$ | async"
					[multiRowLeftHeader]="true"
					[headerColumns]="latestHoldingsColumns"
					[isPortfolioClickable]="enablePortfolioLinks"
					(onPortfolioClicked)="redirectTo360($event)"
					[familyAsOf]="asOfDate"
					(selectedPortfolio)="updateTableDataForSelectedPortfolio($event)"
				></hl-holdings-table-header>
				<hl-scrollable-holdings-table [data]="detailsData" [config]="config"></hl-scrollable-holdings-table>
			</section>
			<ac-disclosure [isExpandable]="false"><span dcrHTMLKey="LATEST_HOLDINGS_DISCLOSURE">LATEST_HOLDINGS_DISCLOSURE</span></ac-disclosure>
			<mb-family-footer *ngIf="showFundPerfTableLink"></mb-family-footer>
		</ng-template>
	</ng-template>
</ng-container>

<ng-template #errorTemplate>
	<div class="margin-object-3 margin-object-0-sm" dcrHTMLKey="LATEST_HOLDINGS_ERROR">The holdings data is currently not available for this model</div>
</ng-template>
<ng-template #loading>
	<mb-family-latest-holdings-skeleton></mb-family-latest-holdings-skeleton>
</ng-template>
